// The owner's Vetproof QR: encodes the scan URL for the pet's microchip, so a vet can scan it
// with Vetproof Scan (or any phone camera, which opens /scan?chip=… directly).
import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { chipUrl, formatChip } from "./scan/chip";

export function PetQr({ chip, name }: { chip: string; name: string }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    QRCode.toDataURL(chipUrl(chip), { margin: 1, width: 440, errorCorrectionLevel: "M", color: { dark: "#162533", light: "#ffffff" } })
      .then(setSrc, () => setSrc(null));
  }, [chip]);
  return (
    <div className="pet-qr" data-notranslate>
      {src ? <img src={src} alt={`Vetproof QR code for ${name}`} /> : <div className="spinner" />}
      <div>
        <div className="t1">{name}'s Vetproof ID</div>
        <div className="t2" style={{ margin: "4px 0 8px" }}>Show this code at any Vetproof clinic — the vet scans it to open the verified record, even without an RFID reader.</div>
        <code>{formatChip(chip)}</code>
        {src && <div style={{ marginTop: 10 }}><a className="btn ghost sm" href={src} download={`vetproof-${name.toLowerCase()}-${chip}.png`}>Download QR</a></div>}
      </div>
    </div>
  );
}
